var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPh = function SvgIconPh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 0v12l-8.485 8.485A11.96 11.96 0 0 0 12 24c6.627 0 12-5.373 12-12S12 0 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 0a11.96 11.96 0 0 0-8.485 3.515L12 12h12c0-6.627-5.373-12-12-12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.217 12-1.465-.69.78-1.419-1.591.305-.202-1.608L4.631 9.77 3.522 8.588l-.202 1.608-1.59-.305.78 1.42L1.043 12l1.465.69-.78 1.418 1.592-.304.201 1.608 1.109-1.183 1.108 1.183.202-1.608 1.591.304-.78-1.419zM3.2 4.695l.489.682.798-.253-.497.674.487.682-.795-.265-.497.675.006-.839-.795-.264.799-.254zM3.2 17.11l.489.681.798-.253-.497.675.487.681-.795-.264-.497.674.006-.838-.795-.265.799-.253zM10.156 10.903l-.488.682-.799-.253.498.674-.488.682.795-.265.498.675-.006-.839.795-.264-.799-.254z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPh;